import styled from 'styled-components'

const TagFilterStyle = styled.div.attrs()`
	.search {
		flex: 1;
		margin-bottom: var(--sp5x);

		.popular-topics {
            flex-wrap:wrap;
			margin-top: var(--sp2-5x);

			.tit {
				margin-right: var(--spSize);
				margin-top: -7px;
			}
		}

		.ant-select {
			border: none;
			padding: 0;
		}

		.op-search {
			&:before {
				font-size: var(--sp2-5x);
			}
		}
	}
`

export default TagFilterStyle
